export const Language = Object.freeze({
  'ENGLISH': 'EN',
  'FRENCH': 'FR'
});
